import {Component, OnInit} from '@angular/core';
import {DialogModule} from '../../dumb/dialog/dialog.module';
import {MatDialogRef} from '@angular/material/dialog';
import {FeatureFlagQuery} from '../../../common/elf-store/feature-flag/feature-flag.query';
import {AutoUnsubscribe} from '../../../decorators/auto-unsubscribe.decorator';
import {SUBSCRIPTIONS} from '../../../common/utils/constants';
import {FeatureFlagListItem} from '../../../common/elf-store/feature-flag/feature-flag.store';
import {FeatureFlagManager} from '../../../common/elf-store/feature-flag/feature-flag.manager';

@Component({
  selector: 'mc-feature-flag-modal',
  standalone: true,
  imports: [DialogModule],
  templateUrl: './feature-flag-modal.component.html',
  styleUrl: './feature-flag-modal.component.scss',
})
@AutoUnsubscribe()
export class FeatureFlagModalComponent implements OnInit {
  featureFlagOptions: FeatureFlagListItem[] = [];
  constructor(
    public dialogRef: MatDialogRef<FeatureFlagModalComponent>,
    private featureFlagManager: FeatureFlagManager,
    private featureFlagQuery: FeatureFlagQuery,
  ) {}

  ngOnInit() {
    this[SUBSCRIPTIONS].add(
      this.featureFlagQuery.featureList$.subscribe((response: FeatureFlagListItem[]) => {
        this.featureFlagOptions = response;
      }),
    );
  }

  changeSelection(feature: FeatureFlagListItem): void {
    this.featureFlagManager.toggleFeature(feature.key);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
